import base64 from 'base-64'
import Cookies from 'js-cookie'
export const URL_INCOMING = 'url_incoming'
export const TOKEN = 'token'
export const EXPIRES_ON = 'expires_on'
export const EXPIRES_DATE = 'expires_date'
export const USER_ID = 'user_id'
export const EMP_ID = 'emp_id'
export const FULL_NAME = 'fullname'
export const ROLE = 'role'
export const EMAIL = 'email'
export const O365_TOKEN = 'o365_token'
export const USER_IMAGE = 'user_image'
export const DEVICE_ADMIN = 'DEVICE_ADMIN'
export const IS_ADMIN = 'is_admin'
export const STATION_DISPLAY = 'station_display'
export const PICKING_DISPLAY = 'picking_display'
export const REPORT_AS_FINISH_DISPLAY = 'report_as_finish_display'
export const JOB_CARD_DISPLAY = 'job_card_display'
export const WARE_HOUSE_DISPLAY = 'ware_house_display'
export const STATION_NAME_DISPLAY = 'station_name_display'
export const DISPLAY_SETTINGS = 'display_settings'
export const DEVICE_ID = 'deviceId'
export const DEVICE_NAME = 'deviceName'

export const DISPLAY_NAME = 'display_name'
export const TABLE_NAME_ACTIVE = 'table_name_active'
export const FULL_NAME_TH = 'fullnameTh'
export const FULL_NAME_EN = 'fullnameEn'
export const DELEGATE_TO_ME = 'delegateToMe'
export const DATA_AREA = 'area'
export const TEAM_ID = 'teamId'
export const URL_DOCUMENT = 'url_document'
export const URL_AUTH_TICATION_EMP_MODE = 'url_auth_tication_emp_mode'
export const CLIENT_ID = 'client_id'
export const URL_SET_O365_TOKEN_COOKIE = 'url_set_o365_token_cookie'
export const URL_SET_USER_IMAGE_COOKIE = 'url_set_user_image_cookie'
export const URL_SET_DATA_AREA = 'url_set_data_area'
export const URL_AUTHEN_TICATION_DEVICE = 'url_authen_tication_device'
export const URL_DEVICE_ADMIN = 'url_device_admin'
export const URL_IS_ADMIN = 'url_is_admin'

export function getCookie(key) {
    try {
        const value = Cookies.get(key)
        let setValue = ''

        if (value && typeof value === 'string') {
            setValue = base64.decode(value)
        }
        return setValue
    } catch (error) {
        return null
    }
}
export function getAllCookies() {
    return {
        [TOKEN]: getCookie(TOKEN),
        [EXPIRES_ON]: getCookie(EXPIRES_ON),
        [EXPIRES_DATE]: getCookie(EXPIRES_DATE),
        [USER_ID]: getCookie(USER_ID),
        [DEVICE_ADMIN]: getCookie(DEVICE_ADMIN),
        [IS_ADMIN]: getCookie(IS_ADMIN),
        [DELEGATE_TO_ME]: getCookie(DELEGATE_TO_ME),
        
    }
}
export function getToken() {
    return getCookie(TOKEN)
}

export function authentication(dataAuth) {
    const {
        user: { email, fullName, id, deviceAdmin, isAdmin, imageUrl, firstNameEN, firstNameTH, lastNameEN, lastNameTH, username, delegateToMeIds,teamId },
        dataArea,
        token,
        expiresDate,
        expiresOn
    } = dataAuth
    clearToken()
    const fullnameEn = `${firstNameEN} ${lastNameEN}`
    const fullnameTh = `${firstNameTH} ${lastNameTH}`
    setCookie(FULL_NAME, fullName)
    setCookie(FULL_NAME_TH, btoa(unescape(encodeURIComponent(fullnameTh))))
    setCookie(FULL_NAME_EN, btoa(unescape(encodeURIComponent(fullnameEn))))
    // setCookie(FULL_NAME_EN, fullnameEn)
    setCookie(EMAIL, email)
    setCookie(USER_ID, id)
    setCookie(DATA_AREA, dataArea)

    setCookie(TOKEN, token)
    setCookie(EXPIRES_DATE, expiresDate)
    setCookie(EXPIRES_ON, expiresOn)
    setCookie(DEVICE_ADMIN, deviceAdmin)
    setCookie(IS_ADMIN, isAdmin)
    setCookie(DISPLAY_NAME, username)
    setCookie(USER_IMAGE, imageUrl)
    setCookie(TEAM_ID, teamId)
    setCookie(DELEGATE_TO_ME, JSON.stringify(delegateToMeIds))
}

export function setCookie(key, value, expires) {
    const valueToString = String(value)
    let setValue = ''
    if (typeof valueToString === 'string') {
        setValue = base64.encode(valueToString)
    }
    if (expires && typeof expires === 'number' && expires > 0) {
        Cookies.set(key, setValue, { expires: expires })
    } else {
        Cookies.set(key, setValue)
    }
}

function removeCookie(key) {
    Cookies.remove(key)
}
 
export function clearToken() {
    removeCookie(TOKEN)
    removeCookie(DATA_AREA)
    removeCookie(EXPIRES_DATE)
    removeCookie(USER_ID)
    removeCookie(FULL_NAME)
    removeCookie(FULL_NAME_TH)
    removeCookie(FULL_NAME_EN)
    removeCookie(EMAIL)
    removeCookie(IS_ADMIN)
    removeCookie(DEVICE_ADMIN)
    removeCookie(URL_INCOMING)
    removeCookie(DEVICE_ID)
    removeCookie(DEVICE_ADMIN)
    removeCookie(DEVICE_NAME)
    removeCookie(TEAM_ID)
    removeCookie(DELEGATE_TO_ME)
   
}

export function setUrlIncoming(data) {
    setCookie(URL_INCOMING, data)
}

export function getUrlIncoming() {
    return getCookie(URL_INCOMING)
}

export function authenticationEmpMode() {
    return getCookie(URL_AUTH_TICATION_EMP_MODE)
}
export function setO365TokenCookie() {
    return getCookie(URL_SET_O365_TOKEN_COOKIE)
}
export function setUserImageCookie() {
    return getCookie(URL_SET_USER_IMAGE_COOKIE)
}
export function setDataArea() {
    return getCookie(URL_SET_DATA_AREA)
}
export function authenticationDevice() {
    return getCookie(URL_AUTHEN_TICATION_DEVICE)
}
export function getDeviceAdmin() {
    return getCookie(URL_DEVICE_ADMIN)
}
export function getIsAdmin() {
    return getCookie(URL_IS_ADMIN)
}
export function getUserImageCookie() {
    return getCookie(USER_IMAGE)
}


 


// WEBPACK FOOTER //
// ./src/lib/auth.js